import { cn } from "@repo/ui/lib/utils";

const Logo = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "bg-[url('/logo_black.svg')] dark:bg-[url('/logo.svg')] bg-contain bg-no-repeat max-md:bg-cover aspect-[4.35] w-[200px] h-[51px] max-md:w-[142px] max-md:h-[36px]",
        className,
      )}
    />
  );
};

export { Logo };
